<script>
import BaseVolanInput from './BaseVolanInput';

export default {
  name: 'BaseVolanInputValidate',
  extends: BaseVolanInput,
  inject: {
    volanForm: { default: null }
  },
  inheritAttrs: false,
  props: {
    rules: {
      type: Array,
      default: () => [],
    },
    error: {
      type: Boolean
    },
    maxErrors: {
      type: Number,
      default: 1,
    },
  },
  data(vm) {
    return {
      isPristine: true,
      internalErrorMessages: [],
    };
  },
  computed: {
    isValid() {
      if (this.error || this.internalErrorMessages.length) return false;
      if (!this.rules.length) return true;
      return this.isPristine ? null : true;
    },
  },
  watch: {
    value() {
      this.validate();
    }
  },
  created() {
    this.volanForm?.register(this);
  },
  beforeDestroy: function() {
    this.volanForm?.unregister(this);
  },
  methods: {
    reset() {
      this.resetValidation();
      this.$emit('input', null);
    },
    resetValidation() {
      this.isPristine = true;
      this.internalErrorMessages = [];
    },
    async validate() {
      const results = [];
      for (const rule of this.rules) {
        if (results.length >= this.maxErrors) {
          break;
        }
        const handler = typeof rule === 'function' ? rule : () => rule;
        const result = await handler(this.value);
        if (result === true) continue;
        if (typeof result !== 'string') {
          console.warn(`${result} is not a valid value. Rule functions must return boolean true or a string.`);
          continue;
        }
        results.push(result);
      }
      this.internalErrorMessages = results;
      this.isPristine = false;
      return this.internalErrorMessages;
    }
  }
};
</script>
